import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { FormattedMessage } from 'react-intl';
import ChatItem from '../../../chat/components/ChatItem';
import customizableComponent from '../../../core/hocs/customization';
import useChannelsList from '../../../chat/hooks/useChannelsList';
import { CreateNewChatIcon, RecentContainer, RecentHeader, RecentHeaderLabel, InfiniteScrollContainer, } from './styles';
const RecentChat = ({ onChannelSelect, onAddNewChannelClick, selectedChannelId }) => {
    const [channels, hasMore, loadMore] = useChannelsList();
    return (React.createElement(RecentContainer, null,
        React.createElement(RecentHeader, null,
            React.createElement(RecentHeaderLabel, null,
                React.createElement(FormattedMessage, { id: "chat.chats" })),
            React.createElement(CreateNewChatIcon, { "data-qa-anchor": "chat-create-chat-button", onClick: onAddNewChannelClick })),
        React.createElement(InfiniteScrollContainer, { "data-qa-anchor": "chat-list" },
            React.createElement(InfiniteScroll, { initialLoad: false, hasMore: hasMore, loadMore: loadMore, useWindow: false, 
                // TODO: REMOVE when SDK Provide filter by membership
                threshold: 1, loader: hasMore && React.createElement("span", { key: 0 }, "Loading...") }, Array.isArray(channels) &&
                channels.map((channel) => (React.createElement(ChatItem, { key: channel.channelId, channel: channel, isSelected: selectedChannelId === channel.channelId, onSelect: onChannelSelect })))))));
};
export default customizableComponent('RecentChat', RecentChat);
//# sourceMappingURL=index.js.map